import { render, staticRenderFns } from "./ChatComponent.vue?vue&type=template&id=0506a8fe&scoped=true"
import script from "./ChatComponent.vue?vue&type=script&lang=js"
export * from "./ChatComponent.vue?vue&type=script&lang=js"
import style0 from "./ChatComponent.vue?vue&type=style&index=0&id=0506a8fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0506a8fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0506a8fe')) {
      api.createRecord('0506a8fe', component.options)
    } else {
      api.reload('0506a8fe', component.options)
    }
    module.hot.accept("./ChatComponent.vue?vue&type=template&id=0506a8fe&scoped=true", function () {
      api.rerender('0506a8fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatComponent.vue"
export default component.exports